<header class="header">
  <h2>{{ labelService.getLabel("reminder") }}</h2>
  <div class="header-buttons">
    @if (isMobile) {
      <app-button
        [size]="'icon-small'"
        [icon]="'swap_horiz'"
        color="light-green"
        (click)="switchSectionMobile()"
      ></app-button>
    }
    <app-button
      [icon]="'add'"
      [size]="'icon-small'"
      (click)="toggleAddReminderPanel()"
    ></app-button>
  </div>
</header>

<!-- Replace filter button with chips -->
<div class="filter-chips">
  <div
    class="chip"
    [class.active-green]="selectedFilterForReminders === 'Non completati'"
    (click)="handleFilterSelect('Non completati')"
  >
    Non completati
  </div>
  <div
    class="chip"
    [class.active-blue]="selectedFilterForReminders === 'Tutti'"
    (click)="handleFilterSelect('Tutti')"
  >
    Tutti
  </div>
</div>
@if (reminders.length > 0) {
  <table class="reminder-table">
    @for (reminder of filteredReminders; track reminder) {
      <div class="reminder-row">
        <span
          class="reminder-text"
          (click)="toggleUpdateReminderPanel(reminder)"
          >{{ reminder.description }}</span
        >
        <app-checkbox
          [checked]="reminder.completed"
          [size]="15"
          [color]="'light-blue-logo'"
          (change)="checkReminder(reminder)"
        ></app-checkbox>
        @if (selectedFilterForReminders === "Tutti") {
          <mat-icon
            style="font-size: 20px; cursor: pointer"
            (click)="deleteReminder(reminder)"
            >delete</mat-icon
          >
        }
      </div>
    }
  </table>
}
@if (filteredReminders.length === 0) {
  <div class="no-reminders">
    <img src="assets/imgs/undraw/undraw_void.svg" alt="Nessun Promemoria" />
    <span>Nessun promemoria disponibile</span>
  </div>
}

<!-- add reminder panel -->
@if (showAddReminderPanel) {
  <app-panel-with-text-area
    [title]="'Nuovo Promemoria'"
    (close)="toggleAddReminderPanel()"
    (confirm)="createNewReminder($event)"
  ></app-panel-with-text-area>
}

<!-- update reminder panel -->
@if (showUpdateReminderPanel) {
  <app-panel-with-text-area
    [title]="'Vuoi modificare il promemoria?'"
    [text]="selectedReminder.description"
    (close)="toggleUpdateReminderPanel()"
    (confirm)="updateReminder($event)"
  ></app-panel-with-text-area>
}
